module.exports = __webpack_public_path__ + "img/devon-logo-2.e11d2507.png";